import { useState, useEffect } from "react";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  const checkIfMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Specific checks for iOS and Android devices
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/i.test(userAgent);
    const isWindowsPhone = /Windows Phone/.test(userAgent);

    // Check for touch capabilities (includes iPadOS as well)
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    // Detect if it's an Apple device (iPhone/iPad)
    const isAppleDevice = /Mac|iPad|iPhone|iPod/.test(userAgent);

    const isSmallScreen = window.matchMedia("(max-width: 640px)").matches;

    // Decision based on combined factors
    if (isIOS || isAndroid || isWindowsPhone || (isAppleDevice && isTouchDevice) || isSmallScreen) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    // resize
    window.addEventListener("resize", checkIfMobile);
    // initial
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  return isMobile;
};

export default useIsMobile;
